"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useClient } from "@repo/design-system/utils/client/client";
import { cn } from "@repo/design-system/utils/cn";
import { useEffect, useState } from "react";
import useToggleAnimationState from "~/hooks/use-toggle-animation-state";
import { useLanguage } from "~/translations/loader/use-language";
const CAREER_NAV_LABEL = "Karriere & Jobs";

/** E.ON Grid Solutions marketing header (legacy HeaderMain.eon.eongrid). */
export default function HeaderMainEonGridsolutions() {
  const $ = _c(117);
  const [height, setHeight] = useState(0);
  const locale = useLocale();
  const client = useClient();
  const jobBoardHref = `/${locale}/${client}`;
  const t = useLanguage();
  const [showMenuAbout, renderMenuAbout, handleTransitionEndMenuAbout, toggleMenuAbout, closeMenuAbout] = useToggleAnimationState();
  const [showMenuCareer, renderMenuCareer, handleTransitionEndMenuCareer, toggleMenuCareer, closeMenuCareer] = useToggleAnimationState();
  const [showMobileMenuCareer, renderMobileMenuCareer, handleTransitionEndMobileMenuCareer, toggleMobileMenuCareer, closeMobileMenuCareer] = useToggleAnimationState();
  const [showMobileMenuAbout, renderMobileMenuAbout, handleTransitionEndMobileMenuAbout, toggleMobileMenuAbout, closeMobileMenuAbout] = useToggleAnimationState();
  let t0;
  if ($[0] !== closeMobileMenuCareer) {
    t0 = newState => {
      closeMobileMenuCareer();
      document.body.style.overflow = newState ? "hidden" : "auto";
    };
    $[0] = closeMobileMenuCareer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [showMobileMenu, renderMobileMenu, handleTransitionEndMobileMenu, toggleMobileMenu, closeMobileMenu] = useToggleAnimationState(t0);
  let t1;
  if ($[2] !== closeMenuCareer || $[3] !== toggleMenuAbout) {
    t1 = () => {
      toggleMenuAbout();
      closeMenuCareer();
    };
    $[2] = closeMenuCareer;
    $[3] = toggleMenuAbout;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleAboutButtonClick = t1;
  let t2;
  if ($[5] !== closeMenuAbout || $[6] !== toggleMenuCareer) {
    t2 = () => {
      toggleMenuCareer();
      closeMenuAbout();
    };
    $[5] = closeMenuAbout;
    $[6] = toggleMenuCareer;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleCareerButtonClick = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setHeight(window.innerHeight);
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== showMobileMenu) {
    t4 = [showMobileMenu];
    $[9] = showMobileMenu;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== closeMenuAbout || $[12] !== closeMenuCareer) {
    t5 = () => {
      setTimeout(() => {
        closeMenuCareer();
        closeMenuAbout();
      }, 500);
    };
    $[11] = closeMenuAbout;
    $[12] = closeMenuCareer;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleMouseLeave = t5;
  let t6;
  let t7;
  if ($[14] !== closeMobileMenu || $[15] !== renderMobileMenu) {
    t6 = () => {
      if (!renderMobileMenu) {
        return;
      }
      const onKeyDown = event => {
        if (event.code === "Escape") {
          closeMobileMenu();
        }
      };
      document.body.addEventListener("keydown", onKeyDown);
      return () => document.body.removeEventListener("keydown", onKeyDown);
    };
    t7 = [renderMobileMenu, closeMobileMenu];
    $[14] = closeMobileMenu;
    $[15] = renderMobileMenu;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[18] !== closeMenuAbout || $[19] !== closeMenuCareer || $[20] !== renderMenuAbout || $[21] !== renderMenuCareer) {
    t8 = () => {
      if (!(renderMenuCareer || renderMenuAbout)) {
        return;
      }
      const onKeyDown_0 = event_0 => {
        if (event_0.code === "Escape") {
          closeMenuCareer();
          closeMenuAbout();
        }
      };
      document.body.addEventListener("keydown", onKeyDown_0);
      return () => document.body.removeEventListener("keydown", onKeyDown_0);
    };
    t9 = [renderMenuCareer, renderMenuAbout, closeMenuCareer, closeMenuAbout];
    $[18] = closeMenuAbout;
    $[19] = closeMenuCareer;
    $[20] = renderMenuAbout;
    $[21] = renderMenuCareer;
    $[22] = t8;
    $[23] = t9;
  } else {
    t8 = $[22];
    t9 = $[23];
  }
  useEffect(t8, t9);
  let t10;
  if ($[24] !== closeMobileMenu || $[25] !== closeMobileMenuCareer) {
    t10 = () => {
      closeMobileMenuCareer();
      closeMobileMenu();
    };
    $[24] = closeMobileMenu;
    $[25] = closeMobileMenuCareer;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const closeMobileNavToJobBoard = t10;
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="sr-only">Toggle mobile menu</span>;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = showMobileMenu && "translate-y-2 rotate-45";
  let t13;
  if ($[28] !== t12) {
    t13 = cn(t12, "absolute top-0 block w-full border-foreground border-t-2 transition-all duration-300");
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <span className={t13} />;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = showMobileMenu && "opacity-0";
  let t16;
  if ($[32] !== t15) {
    t16 = cn(t15, "absolute top-1/2 block w-full border-foreground border-t-2 transition-all");
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <span className={t16} />;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = showMobileMenu && "-translate-y-2 -rotate-45";
  let t19;
  if ($[36] !== t18) {
    t19 = cn(t18, "absolute top-full block w-full border-foreground border-t-2 transition-all duration-300");
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <span className={t19} />;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t14 || $[41] !== t17 || $[42] !== t20) {
    t21 = <div className="relative top-6 left-6 h-4 w-6">{t14}{t17}{t20}</div>;
    $[40] = t14;
    $[41] = t17;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21 || $[45] !== toggleMobileMenu) {
    t22 = <button className="absolute top-0 left-0 flex h-full w-16 lg:hidden" onClick={toggleMobileMenu} type="button">{t11}{t21}</button>;
    $[44] = t21;
    $[45] = toggleMobileMenu;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <li className="h-full"><CustomLink blank={true} className="flex h-full items-center px-3 hover:bg-[#f6f6f7] xl:px-4" data-source="text" href="https://www.eon-gridsolutions.com/de.html">Home</CustomLink></li>;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  const t24 = showMenuAbout && "border-gray-300 border-b-4 bg-[#f6f6f7]";
  let t25;
  if ($[48] !== t24) {
    t25 = cn(t24, "box-border flex h-full px-3 py-[25.5px] hover:bg-[#f6f6f7] xl:px-2");
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t25) {
    t26 = <span className={t25} data-source="text">Über uns</span>;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== handleAboutButtonClick || $[53] !== showMenuAbout || $[54] !== t26) {
    t27 = <button aria-expanded={showMenuAbout} onClick={handleAboutButtonClick} type="button">{t26}</button>;
    $[52] = handleAboutButtonClick;
    $[53] = showMenuAbout;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== handleTransitionEndMenuAbout || $[57] !== renderMenuAbout || $[58] !== showMenuAbout) {
    t28 = renderMenuAbout && <div className="!z-10 absolute top-full left-0 mt-1 hidden h-auto w-full text-left lg:flex" onTransitionEnd={handleTransitionEndMenuAbout}><div className="w-full overflow-hidden"><div className={cn(showMenuAbout ? "-translate-y-0" : "-translate-y-full", "flex w-full justify-between bg-[#f6f6f7] shadow-xl transition-all duration-700")}><div className="mx-auto mb-4 flex w-full max-w-screen-xl justify-between gap-x-8 px-6 pt-6 text-[1.35rem]"><ul className="font-light text-lg"><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/ueber-uns/eon-grid-solutions.html">E.ON Grid Solutions</CustomLink></li><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/ueber-uns/geschaeftsfuehrung.html">Geschäftsführung</CustomLink></li><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/ueber-uns/team.html">Unser Team</CustomLink></li></ul></div></div></div></div>;
    $[56] = handleTransitionEndMenuAbout;
    $[57] = renderMenuAbout;
    $[58] = showMenuAbout;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t27 || $[61] !== t28) {
    t29 = <li>{t27}{t28}</li>;
    $[60] = t27;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  const t30 = showMenuCareer && "border-gray-300 border-b-4 bg-[#f6f6f7]";
  let t31;
  if ($[63] !== t30) {
    t31 = cn(t30, "box-border flex h-full px-3 py-[25.5px] hover:bg-[#f6f6f7] xl:px-2");
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t31) {
    t32 = <span className={t31} data-source="text">{CAREER_NAV_LABEL}</span>;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== handleCareerButtonClick || $[68] !== showMenuCareer || $[69] !== t32) {
    t33 = <button aria-expanded={showMenuCareer} onClick={handleCareerButtonClick} type="button">{t32}</button>;
    $[67] = handleCareerButtonClick;
    $[68] = showMenuCareer;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== closeMenuCareer || $[72] !== handleTransitionEndMenuCareer || $[73] !== jobBoardHref || $[74] !== renderMenuCareer || $[75] !== showMenuCareer) {
    t34 = renderMenuCareer && <div className="!z-10 absolute top-full left-0 mt-1 hidden h-auto w-full text-left lg:flex" onTransitionEnd={handleTransitionEndMenuCareer}><div className="w-full overflow-hidden"><div className={cn(showMenuCareer ? "-translate-y-0" : "-translate-y-full", "flex w-full justify-between bg-[#f6f6f7] shadow-xl transition-all duration-700")}><div className="mx-auto flex w-full max-w-screen-xl justify-between gap-x-8 px-6 py-8 pt-6 text-[1.35rem]"><ul className="font-light text-lg"><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/arbeitgeberleistungen.html">Arbeitgeberleistungen</CustomLink></li><li className="mb-3"><CustomLink className="hover:underline" data-source="text" href={jobBoardHref} onClick={closeMenuCareer} prefetch={false}>Stellenangebote</CustomLink></li><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/eon-grid-solutions-graduate-programme.html">Traineeprogramm</CustomLink></li><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://ausbildung.eon.com/?utm_source=careerpage&utm_medium=Link&utm_campaign=JobShop">{"Ausbildung & duales Studium"}</CustomLink></li><li className="mb-3"><CustomLink blank={true} className="hover:underline" data-source="text" href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/werkstudenten.html">Werkstudentinnen und Werkstudenten</CustomLink></li></ul></div></div></div></div>;
    $[71] = closeMenuCareer;
    $[72] = handleTransitionEndMenuCareer;
    $[73] = jobBoardHref;
    $[74] = renderMenuCareer;
    $[75] = showMenuCareer;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== t33 || $[78] !== t34) {
    t35 = <li>{t33}{t34}</li>;
    $[77] = t33;
    $[78] = t34;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== t29 || $[81] !== t35) {
    t36 = <ul className="hidden h-full items-center text-lg leading-4 lg:flex">{t23}{t29}{t35}</ul>;
    $[80] = t29;
    $[81] = t35;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t22 || $[84] !== t36) {
    t37 = <div className="flex h-full w-full justify-end lg:justify-between">{t22}{t36}</div>;
    $[83] = t22;
    $[84] = t36;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== closeMobileMenu || $[87] !== closeMobileMenuAbout || $[88] !== closeMobileMenuCareer || $[89] !== closeMobileNavToJobBoard || $[90] !== handleTransitionEndMobileMenu || $[91] !== handleTransitionEndMobileMenuAbout || $[92] !== handleTransitionEndMobileMenuCareer || $[93] !== height || $[94] !== jobBoardHref || $[95] !== renderMobileMenu || $[96] !== renderMobileMenuAbout || $[97] !== renderMobileMenuCareer || $[98] !== showMobileMenu || $[99] !== showMobileMenuAbout || $[100] !== showMobileMenuCareer || $[101] !== t || $[102] !== toggleMobileMenuAbout || $[103] !== toggleMobileMenuCareer) {
    t38 = renderMobileMenu && <div className="mt-1 -ml-6 md:-ml-10"><button aria-hidden={true} className={cn(showMobileMenu ? "-translate-x-0 opacity-60" : "-translate-x-full opacity-0", "absolute w-full cursor-default bg-black transition-opacity duration-700 lg:hidden")} onClick={closeMobileMenu} style={{
        minHeight: height
      }} tabIndex={-1} type="button" /><div className={cn(showMobileMenu ? "-translate-x-0" : "-translate-x-full", "left-0 w-[296px] overflow-y-auto overflow-x-hidden bg-[#f6f6f7] transition-all duration-700 md:w-[305px] lg:hidden")} onTransitionEnd={handleTransitionEndMobileMenu} style={{
        minHeight: height - 68
      }}><div className="pt-0"><ul className="text-lg leading-4 transition-all duration-300"><li className="h-full"><CustomLink blank={true} className="flex justify-between border-gray-200 border-b px-4 py-3 leading-6" href="https://www.eon-gridsolutions.com/de.html">Home</CustomLink></li><li className="h-full"><CustomLink blank={true} className="flex justify-between border-gray-200 border-b px-4 py-3 leading-6" href="https://www.eon-gridsolutions.com/de/leistungsportfolio/eon-space.html">E.ON Space</CustomLink></li><li className="border-gray-200 border-b"><button className="w-full px-4 py-3 leading-6" onClick={toggleMobileMenuAbout} type="button"><span className="flex justify-between"><span>Über uns</span><CustomImage alt="" height={24} src="images/icons/chevron_bold_right.svg" width={20} /></span></button>{renderMobileMenuAbout && <div className={cn(showMobileMenuAbout && "-translate-x-full", "absolute top-0 left-full h-[1050px] w-full bg-[#f6f6f7] text-left text-2xl transition-all duration-700")} onTransitionEnd={handleTransitionEndMobileMenuAbout}><button aria-label={t.header_back_button_title} className="sticky my-2 flex w-full items-center gap-x-2 px-6 py-3 font-extrabold text-2xl leading-6" onClick={closeMobileMenuAbout} title={t.header_back_button_title} type="button"><CustomImage alt="" className="rotate-180" height={24} src="images/icons/chevron_bold_right.svg" width={20} /><span>Über uns</span></button><ul className="pb-4 font-light text-lg leading-6"><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/ueber-uns/eon-grid-solutions.html">E.ON Grid Solutions</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/ueber-uns/geschaeftsfuehrung.html">Geschäftsführung</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/ueber-uns/team.html">Unser Team</CustomLink></li></ul></div>}</li><li className="border-gray-200 border-b"><button className="w-full px-4 py-3 leading-6" onClick={toggleMobileMenuCareer} type="button"><span className="flex justify-between"><span data-source="lc">{CAREER_NAV_LABEL}</span><CustomImage alt="" height={24} src="images/icons/chevron_bold_right.svg" width={20} /></span></button>{renderMobileMenuCareer && <div className={cn(showMobileMenuCareer && "-translate-x-full", "absolute top-0 left-full h-[1050px] w-full bg-[#f6f6f7] text-left text-2xl transition-all duration-700")} onTransitionEnd={handleTransitionEndMobileMenuCareer}><button aria-label={t.header_back_button_title} className="sticky my-2 flex w-full items-center gap-x-2 px-6 py-3 font-extrabold text-2xl" onClick={closeMobileMenuCareer} title={t.header_back_button_title} type="button"><CustomImage alt="" className="rotate-180" height={24} src="images/icons/chevron_bold_right.svg" width={20} /><span data-source="lc">{CAREER_NAV_LABEL}</span></button><ul className="pb-4 font-light text-lg leading-6"><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/arbeitgeberleistungen.html">Arbeitgeberleistungen</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink href={jobBoardHref} onClick={closeMobileNavToJobBoard} prefetch={false}>Stellenangebote</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/eon-grid-solutions-graduate-programme.html">Traineeprogramm</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://ausbildung.eon.com/?utm_source=careerpage&utm_medium=Link&utm_campaign=JobShop">{"Ausbildung & duales Studium"}</CustomLink></li><li className="border-gray-200 border-t px-6 py-3"><CustomLink blank={true} href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/werkstudenten.html">Werkstudentinnen und Werkstudenten</CustomLink></li></ul></div>}</li></ul></div></div></div>;
    $[86] = closeMobileMenu;
    $[87] = closeMobileMenuAbout;
    $[88] = closeMobileMenuCareer;
    $[89] = closeMobileNavToJobBoard;
    $[90] = handleTransitionEndMobileMenu;
    $[91] = handleTransitionEndMobileMenuAbout;
    $[92] = handleTransitionEndMobileMenuCareer;
    $[93] = height;
    $[94] = jobBoardHref;
    $[95] = renderMobileMenu;
    $[96] = renderMobileMenuAbout;
    $[97] = renderMobileMenuCareer;
    $[98] = showMobileMenu;
    $[99] = showMobileMenuAbout;
    $[100] = showMobileMenuCareer;
    $[101] = t;
    $[102] = toggleMobileMenuAbout;
    $[103] = toggleMobileMenuCareer;
    $[104] = t38;
  } else {
    t38 = $[104];
  }
  let t39;
  if ($[105] !== t37 || $[106] !== t38) {
    t39 = <nav>{t37}{t38}</nav>;
    $[105] = t37;
    $[106] = t38;
    $[107] = t39;
  } else {
    t39 = $[107];
  }
  let t40;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <CustomImage alt="E.ON Grid Solutions" height={32} src="images/logo/logo.svg" width={109} />;
    $[108] = t40;
  } else {
    t40 = $[108];
  }
  let t41;
  if ($[109] !== jobBoardHref) {
    t41 = <div className="flex items-center"><CustomLink className="-mb-1" href={jobBoardHref} prefetch={false} title="E.ON Grid Solutions">{t40}</CustomLink></div>;
    $[109] = jobBoardHref;
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== t39 || $[112] !== t41) {
    t42 = <div className="mx-auto flex h-16 max-w-screen-xl justify-between text-center">{t39}{t41}</div>;
    $[111] = t39;
    $[112] = t41;
    $[113] = t42;
  } else {
    t42 = $[113];
  }
  let t43;
  if ($[114] !== handleMouseLeave || $[115] !== t42) {
    t43 = <header className="sticky top-0 z-50 h-16 w-full bg-white print:hidden"><div className="relative w-full border-gray-200 border-b-4 px-6 md:px-10" onMouseLeave={handleMouseLeave}>{t42}</div></header>;
    $[114] = handleMouseLeave;
    $[115] = t42;
    $[116] = t43;
  } else {
    t43 = $[116];
  }
  return t43;
}